import { useLayoutEffect } from 'react';

export const SETTINGS_SCROLL_CONTAINER_ID = 'settings';

/**
 * Resets the settings content area and every overflow ancestor (including the
 * app `main` scroller) so add/edit screens open at the top instead of inheriting
 * the previous list's scroll offset.
 */
export function resetSettingsScroll(): void {
	if (typeof document === 'undefined') {
		return;
	}

	const settings = document.getElementById(SETTINGS_SCROLL_CONTAINER_ID);
	let node: HTMLElement | null = settings ?? document.documentElement;

	while (node) {
		if (node.scrollTop !== 0) {
			node.scrollTop = 0;
		}
		node = node.parentElement;
	}

	window.scrollTo(0, 0);
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
}

/**
 * Scrolls settings back to the top whenever `viewKey` changes (tab, subsection,
 * or add/edit view).
 */
export function useResetSettingsScroll(viewKey: unknown): void {
	useLayoutEffect(() => {
		resetSettingsScroll();
	}, [viewKey]);
}
